export function on<T>(event: string, callback: (event: CustomEvent<T>) => void) {
  document.addEventListener(event, callback as EventListener)
  return () => document.removeEventListener(event, callback as EventListener)
}

export function off(event: string, callback: (data: any) => void) {
  document.removeEventListener(event, callback)
}

export function fire<T>(event: string, detail: T) {
  document.dispatchEvent(new CustomEvent(event, { detail }))
}
